import {
  faCaretDown,
  faCaretUp,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { changeFormulaType } from "../../actions/formulaAction";
import {
  formPostAction,
  getRememberSettings,
} from "../../actions/settingsActions";
import { getUserDetail } from "../../utils/helper";

const GranularToRawPopup = ({
  rememberSettings,
  closePopup,
  isRawType,
  setIsRaw,
  setPrepMethod,
  setRawGram,
  setTimePerDay,
  setDays,
  preparationMethods,
}) => {
  const dispatch = useDispatch();
  const [scoop, setScoop] = useState(0);
  const [time, setTime] = useState(0);

  const updateField = (fields) => {
    const params = {
      token: getUserDetail()?.token,
      fields: fields,
      action: "updateRememberSettings",
    };

    dispatch(
      formPostAction(
        {
          params,
        },
        () => {
          dispatch(
            getRememberSettings(() => {
              closePopup();
            })
          );
        }
      )
    );
  };

  return (
    <Modal show={true} id="prescription-popup" size="lg">
      <Modal.Body>
        <>
          <div className="prescription-detail">
            <div className="close-btn">
              <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
            </div>
            <div className="inner-section">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="heading">
                    We do not recommend starting in granular as different herbs
                    are produced at different concentrations, making it
                    complicated for you to calculate dosages. Write a raw
                    formula instead and we will accurately calculate the dosages
                    and conversions for you! Proceed with caution.
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="submit-section d-flex justify-content-end">
            <div className="custom-control custom-checkbox custom-popup">
              <input
                type="checkbox"
                className="custom-control-input hidden-checkbox"
                id="remember"
                style={{ color: "white", marginRight: "10px" }}
                checked={!rememberSettings?.showGranularConversionPopup}
                onChange={() => {
                  updateField({
                    ...rememberSettings,
                    showGranularConversionPopup: 0,
                  });
                }}
              />
              <label
                className="custom-control-label on-builder"
                style={{
                  color: "white",
                  marginLeft: "10px",
                  paddingTop: "4px",
                  paddingLeft: "5px",
                }}
                htmlFor="remember"
              >
                Do not show this message again
              </label>
            </div>
            <button
              className="btn-orange"
              onClick={() => {
                setRawGram();
                dispatch(changeFormulaType(!isRawType, 0));
                setPrepMethod &&
                  setPrepMethod(preparationMethods?.find((x) => x.id == 1));
                closePopup();
                setDays(0);
                setTimePerDay && setTimePerDay(0);
              }}
            >
              Proceed
            </button>
          </div>
        </>
      </Modal.Body>
    </Modal>
  );
};
export default GranularToRawPopup;
